import { ERROR, HOMEWORK_EXECUTION, PAUSE, RESULTS, START_PAGE } from '../../constants/routes';
import {
    EXPIRING_ASSIGNMENT_FRESH,
    calculateVoteTraining,
    getStatus,
    getStatusArrayByAssignmentId,
    getStatusArrayByGoogleClassroomAddOnSubmissionId,
    getStatusById,
    pauseHomework,
    saveScoreModifier,
    sendTimeRemote,
    showExerciseCorrection,
    startHomework,
    terminateHomework,
    tick,
    updateExerciseStatus,
    updateHomeworkVersion,
} from '../../actions/status';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Route, useNavigate, useLocation, Routes } from 'react-router-dom';
import {
    appLoadedCompleted,
    appLoadedPending,
    initializeApplication,
    onStartPageCheckboxClick,
    toggleHintBox,
} from '../../actions/application';
import {
    errorType,
    getAssignmentById,
    getGoogleAssignmentEndDate,
    GET_ASSIGNMENT_ERROR,
    setAssignmentError,
} from '../../actions/assignment';
import { getExerciseById, getHomework, getTrymeById, validateCheckerStep } from '../../actions/homework';
import { resumeLogin, setLazeUser } from '../../actions/auth';
import { showModal, hideModal, showNotLoggedModal as showNotLoggedModalAction, showSendGradeErrorModal } from '../../actions/modal';
import { useGapi, useHeartbeat, useInterval } from '../../lib/hooks';

import { EXECUTION } from '../../constants/execution-modes';
import { FORCED_TERMINATION_MODAL } from '../modal/modal-types';
import ErrorPage from '../error-page';
import ExecutionRoute from '../routes/execution-route';
import Exercise from '../../components/exercise';
import ErrorLayout from '../../components/errors';
import WrongVirtualClass from '../../components/errors/wrong-virtual-class';
import AssignmentExpired from '../../components/errors/assignment-expired';
import ExerciseLoadError from '../../components/exercise-load-error';

import ModalContainer from '../modal';
import PausePage from '../pause-page';
import PauseRoute from '../routes/pause-route';
import PropTypes from 'prop-types';
import ResultsPage, { getPaddingTop } from '../results-page';
import ResultsRoute from '../routes/results-route';
import { STATUS_SYNC_INTERVAL } from '../../config';
import Skeleton from '../../components/skeleton';
import StartPage from '../../components/start-page';
import StartRoute from '../routes/start-route';
import { connect } from 'react-redux';
import { heartbeat as heartbeatAction } from '../../actions/heartbeat';
import { onPlayVideo } from '../../actions/media-player';
import { setLazeLaunch } from '../../lib/axios';
import { getPerformerBackgroundColor, setPageTitle } from '../../lib/utils';
import { SOURCES } from '../../constants/sources';
import { resumeGoogleLogin, resumeGoogleAddOnLogin } from '../../actions/google-auth';

import Layout from '../../components/layouts';
import { PERFORMER, SECTIONS, DEFAULT } from '../../constants/start-page';
import { APPLICATION_MODE } from '../../constants/layout';
import FluidContainer from '../../components/layouts/components/fluid-container';
import AssignmentNotStarted from '../../components/errors/assignment-not-started';

const skeletonItems = [
    { width: 40 },
    { width: 0, height: 'small' },
    { width: 100 },
    { width: 100 },
    { width: 50 },
    { width: 0 },
    { width: 40, height: 'regular' },
    { width: 80, height: 'regular' },
];

const PageWrapper = ({
    answers,
    appLoadedCompleted,
    appLoadedPending,
    application,
    assignmentStatus,
    assignmentEndDate,
    assignmentId,
    attemptsNumber,
    attemptsNumberFinished,
    authStatus,
    authors,
    groupCorrectionByTopic,
    bookId,
    calculateVoteTraining,
    correctionPoints,
    courseTitle,
    currentIndex,
    encodedPayload,
    exercises,
    firstPage,
    geogebraExercises,
    getAssignmentById,
    getExerciseById,
    getGoogleAssignmentEndDate,
    getHomework,
    getStatus,
    getStatusArrayByAssignmentId,
    getStatusArrayByGoogleClassroomAddOnSubmissionId,
    getStatusById,
    getTrymeById,
    googleUserInfo,
    googleUserStatus,
    heartbeatPulse,
    hideModal,
    homeworkCatalogPaths,
    homeworkId,
    homeworkStatus,
    initializeApplication,
    isAppLoaded,
    isAppLoading,
    isLtiLaunch,
    journey,
    notLoggedModalShowed,
    onPlayVideo,
    onStartPageCheckboxClick,
    pauseHomework,
    phase,
    publicTitle,
    repeatTest,
    resumeGoogleLogin,
    resumeGoogleAddOnLogin,
    resumeLogin,
    saveScoreModifier,
    sendGradeErrorModalShowed,
    setAssignmentError,
    sendTimeRemote,
    setLazeUser,
    showExerciseCorrection,
    showModal,
    showNotLoggedModal,
    showSendGradeErrorModal,
    showStartPage,
    startHomework,
    status,
    statusArrayLoaded,
    terminateHomework,
    tick,
    toggleHintBox,
    updateExerciseStatus,
    updateHomeworkVersion,
    validateCheckerStep,
    videos,
    disableLeavePopup,
}) => {
    const [noAttempts, setNoAttempts] = useState(false);
    const [applicationProfile, setApplicationProfile] = useState(undefined);
    const history = useNavigate();
    const location = useLocation();
    const { saveStatus, source, lazeUser } = application;
    const [gApiStatus] = useGapi();

    useHeartbeat();

    useEffect(() => {
        if (!notLoggedModalShowed && !heartbeatPulse) {
            status?.id && pauseHomework(status, saveStatus);
            showNotLoggedModal();
        }
    }, [heartbeatPulse, notLoggedModalShowed, pauseHomework, saveStatus, showNotLoggedModal, status]);

    useEffect(() => {
        setPageTitle(application.source, publicTitle);
    }, [application.source, publicTitle]);

    useEffect(() => {
        if (location.pathname !== RESULTS && repeatTest - attemptsNumberFinished <= 0 && repeatTest > 0) {
            setNoAttempts(true);
            setTimeout(history, 0, ERROR, { replace: true });
        }
    }, [location.pathname, attemptsNumberFinished, history, repeatTest]);

    useEffect(() => {
        if (source === SOURCES.LAZE && lazeUser) {
            setLazeLaunch(lazeUser);
        }
    }, [source, lazeUser]);

    useEffect(() => {
        const initApplication = async () => {
            const result = await initializeApplication(EXECUTION);
            result.scoreModifier && saveScoreModifier(result.scoreModifier);
            result.profile && setApplicationProfile(result.profile);
        };
        initApplication();
    }, [initializeApplication, saveScoreModifier, setApplicationProfile]);

    useEffect(() => {
        if (applicationProfile?.googleCourseWorkId && gApiStatus.success) {
            resumeGoogleLogin();
        }
    }, [applicationProfile, gApiStatus.success, resumeGoogleLogin]);

    useEffect(() => {
        if (isAppLoading || isAppLoaded || !applicationProfile || (applicationProfile.googleCourseWorkId && !googleUserInfo)) {
            return;
        }

        // TODO: refctor to avoid action creator chaining
        const initData = async () => {
            await appLoadedPending();

            if (applicationProfile.googleAddon) {
                resumeGoogleAddOnLogin(applicationProfile.googleIdToken, applicationProfile.googleAccessToken);
            } else if (!applicationProfile.googleCourseWorkId) {
                if (applicationProfile.lazeUser) {
                    setLazeUser(applicationProfile.lazeUser);
                } else {
                    resumeLogin(source === SOURCES.LAZE && isLtiLaunch);
                }
            }

            if (applicationProfile.isTryme) {
                const trymeResult = await getTrymeById(applicationProfile.exerciseId);
                trymeResult && startHomework();
            } else if (applicationProfile.exerciseId && applicationProfile.isPreview) {
                const result = await getExerciseById(applicationProfile.exerciseId);
                result && startHomework();
            } else if (applicationProfile.originalId) {
                let obj;
                if (applicationProfile.assignmentId) {
                    let assignment = await getAssignmentById(applicationProfile.assignmentId);

                    if (applicationProfile.googleCourseWorkId) {
                        const googleAssignmentEndDate = await getGoogleAssignmentEndDate(assignment.classId, assignment.googleCourseWorkId);

                        assignment.endDate = googleAssignmentEndDate;
                    } else {
                        if (applicationProfile.className) {
                            const nowDate = moment();

                            const endDate = moment(assignment.endDate);
                            const startDate = moment(assignment.startDate);

                            if (assignment?.type === GET_ASSIGNMENT_ERROR) {
                                setAssignmentError(errorType.USER_NOT_AUTHORIZED);
                                return;
                            }

                            if (nowDate > endDate) {
                                setAssignmentError(errorType.EXPIRED);
                                return;
                            }
                            if (nowDate < startDate) {
                                setAssignmentError(errorType.NOT_STARTED);
                                return;
                            }
                        }
                    }
                    obj = await getStatus(applicationProfile, assignment);
                } else {
                    obj = await getStatus(applicationProfile);
                    if (applicationProfile.googleAddon) {
                        await getStatusArrayByGoogleClassroomAddOnSubmissionId(applicationProfile.googleSubmissionId);
                    }
                }
                const status = obj.payload;
                const homework = await getHomework(applicationProfile, status);
                if (homework) {
                    updateHomeworkVersion(homework.version);
                }

                if (status && status.id) {
                    setTimeout(history, 0, PAUSE, { replace: true });
                } else if (applicationProfile.showStartPage || firstPage === PERFORMER) {
                    setTimeout(history, 0, START_PAGE, { replace: true });
                } else {
                    startHomework();
                }
            }

            await appLoadedCompleted();
        };

        initData().catch(() => {});

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationProfile, googleUserInfo, isLtiLaunch]);

    const isTimerRunning = () => !status.finished && !status.paused && status.started && !!status.remainingTime;
    useInterval(
        () => {
            if (
                application.saveStatus &&
                !status.httpStatus.updating &&
                isTimerRunning() &&
                status.expiringAssignment !== EXPIRING_ASSIGNMENT_FRESH
            ) {
                sendTimeRemote(status);
            }
        },
        application.saveStatus && isTimerRunning() ? STATUS_SYNC_INTERVAL : null,
        STATUS_SYNC_INTERVAL / 4,
    );

    const currentExercise = exercises[currentIndex];

    const { answer } = answers.find((answer) => currentExercise && answer.exerciseId === currentExercise.id) || { answer: [] };

    const updateStatusWithPreviewContext = (exerciseId, answers) => {
        updateExerciseStatus(exerciseId, answers, status, application.saveStatus);
    };

    const terminateHomeworkAtTimeout = () => {
        terminateHomework(exercises, answers, status, application.saveStatus, application.source);
    };

    const terminateHomeworkForced = () => {
        terminateHomework(exercises, answers, status, false, application.source);
        hideModal();
        showModal(FORCED_TERMINATION_MODAL);
    };

    const correctionStatus = status.correctionsStatus.find((correctionStatus) => correctionStatus.exerciseId === currentExercise.id);

    const isLoading = status.httpStatus.fetching || homeworkStatus.fetching || authStatus.fetching || googleUserStatus.pending;

    const extraLayoutInfo = {
        startPageBackgroundColor: getPerformerBackgroundColor(phase?.name, firstPage),
    };

    let exerciseHeadingData = null;
    if (!!status.sections) {
        const sectionsExercisesCounts = status.sections.map((section) => section.exercisesCount);
        let firstExerciseIndex = 0;
        let lastExerciseIndex = -1;
        let currentSectionIndex;

        for (currentSectionIndex = 0; currentSectionIndex < sectionsExercisesCounts.length; currentSectionIndex++) {
            lastExerciseIndex += sectionsExercisesCounts[currentSectionIndex];
            if (currentIndex >= firstExerciseIndex && currentIndex <= lastExerciseIndex) {
                break;
            }

            firstExerciseIndex += sectionsExercisesCounts[currentSectionIndex];
        }

        exerciseHeadingData = {
            upperText: `Sezione ${currentSectionIndex + 1} di ${status.sections.length}`,
            lowerText: status.sections[currentSectionIndex].name,
        };
    } else if (application?.mode === APPLICATION_MODE.LIGHT && !!homeworkCatalogPaths && !!journey && !!publicTitle) {
        let courseId = homeworkCatalogPaths?.find((i) => i)?.path?.split('.')[0];

        exerciseHeadingData = {
            upperText: `${homeworkCatalogPaths?.find((i) => i)?.chapterTitle}${
                journey?.name && courseId !== '2000273319' ? ` – ${journey?.name}` : ''
            }`,
            lowerText: publicTitle,
        };
    }
    if (assignmentStatus?.error) {
        return (
            <ErrorLayout>
                {assignmentStatus.errorType === errorType.USER_NOT_AUTHORIZED && <WrongVirtualClass />}
                {assignmentStatus.errorType === errorType.NOT_STARTED && <AssignmentNotStarted />}
                {assignmentStatus.errorType === errorType.EXPIRED && <AssignmentExpired />}
            </ErrorLayout>
        );
    }

    return (
        <>
            <Layout
                answers={answers}
                authors={authors}
                courseTitle={courseTitle}
                exercises={exercises}
                extraInfo={extraLayoutInfo}
                homeworkStatus={homeworkStatus}
                isLoading={isLoading}
                mode={application?.mode}
                phase={phase?.name}
                profile={application}
                publicTitle={publicTitle}
                showModal={showModal}
                status={status}
                terminateHomework={terminateHomeworkAtTimeout}
                tick={tick}
            >
                <ModalContainer />

                <Routes>
                    <Route
                        path={START_PAGE}
                        element={
                            <StartRoute>
                                {application.status.completed && !homeworkStatus.error && !status.httpStatus.error ? (
                                    <StartPage
                                        isChecked={!showStartPage}
                                        isLoading={isLoading || !statusArrayLoaded}
                                        onChange={() => onStartPageCheckboxClick(!showStartPage)}
                                        time={application.time}
                                        pausable={application.pauseTest}
                                        assignmentId={assignmentId}
                                        assignmentEndDate={assignmentEndDate}
                                        expiringAssignment={status.expiringAssignment}
                                        remainingTime={status.remainingTime}
                                        maxAttemptsNumber={repeatTest}
                                        attemptsNumber={attemptsNumber}
                                        getStatusArray={getStatusArrayByAssignmentId}
                                        correctable={application.singleAnswer}
                                        source={application.source}
                                        scoreModifier={status.scoreModifier}
                                        isGeneratedHomework={!!status.simulationOfBookId}
                                        phase={phase?.name}
                                        journey={journey?.name}
                                        exercisesTitle={exercises.map((item) => item.publicTitle)}
                                        publicTitle={publicTitle}
                                        courseId={homeworkCatalogPaths?.find((i) => i)?.path?.split('.')[0]}
                                        homeworkChapter={homeworkCatalogPaths?.find((i) => i)?.chapterTitle}
                                        firstPage={firstPage}
                                        sections={application.sections}
                                    />
                                ) : (
                                    <ExerciseLoadError />
                                )}
                            </StartRoute>
                        }
                    />
                    <Route
                        path={RESULTS}
                        element={
                            <ResultsRoute>
                                <ResultsPage
                                    answers={answers}
                                    attemptsNumber={attemptsNumber}
                                    exercises={exercises}
                                    videos={videos}
                                    correctionsStatus={status.correctionsStatus}
                                    onPlayVideo={onPlayVideo}
                                    maxAttemptsNumber={repeatTest}
                                    assignmentId={assignmentId}
                                    assignmentEndDate={assignmentEndDate}
                                    getStatusArray={getStatusArrayByAssignmentId}
                                    geogebraExercises={geogebraExercises}
                                    encodedPayload={encodedPayload}
                                    groupCorrectionByTopic={groupCorrectionByTopic}
                                    loaded={statusArrayLoaded}
                                    correctable={application.singleAnswer}
                                    sendGradeError={status.sendGradeError}
                                    showSendGradeErrorModal={showSendGradeErrorModal}
                                    sendGradeErrorModalShowed={sendGradeErrorModalShowed}
                                    correctionPoints={correctionPoints}
                                    status={status}
                                    saveStatus={application.saveStatus}
                                    getStatusById={getStatusById}
                                    source={application.source}
                                    calculateVoteTraining={calculateVoteTraining}
                                    homeworkId={homeworkId}
                                    bookId={bookId}
                                    isApplicationEmbedded={application.isEmbedded}
                                    isPreview={application.isPreview}
                                    isGoogleAddon={application.googleAddon}
                                    mode={application.mode}
                                />
                            </ResultsRoute>
                        }
                    />
                    <Route
                        path={PAUSE}
                        element={
                            <PauseRoute>
                                <PausePage />
                            </PauseRoute>
                        }
                    />
                    <Route path={ERROR} element={<ErrorPage errorType={noAttempts ? 'TOO_MANY_ATTEMPTS' : 'GENERIC'} />} />
                    <Route
                        path={HOMEWORK_EXECUTION}
                        element={
                            <ExecutionRoute terminateHomework={terminateHomeworkForced}>
                                {(!application.status.completed && application.status.error) ||
                                homeworkStatus.error ||
                                status.httpStatus.error ? (
                                    <ExerciseLoadError />
                                ) : (
                                    <FluidContainer paddingTop={getPaddingTop(application?.mode, exercises.length)} flexDirection="column">
                                        <Skeleton isLoading={isLoading} items={skeletonItems}>
                                            <Exercise
                                                key={currentIndex}
                                                answers={answer}
                                                correctable={application.singleAnswer}
                                                exercise={currentExercise}
                                                exercises={exercises}
                                                id={`tabpanel-${currentIndex}`}
                                                onAnswer={updateStatusWithPreviewContext}
                                                onCorrection={showExerciseCorrection}
                                                onPlayVideo={onPlayVideo}
                                                profile={application}
                                                showModal={showModal}
                                                videos={videos}
                                                homeworkTerminated={status.finished}
                                                time={status.remainingTime}
                                                correctionStatus={correctionStatus}
                                                hintBoxIsOpen={
                                                    currentExercise &&
                                                    application.closedHintBox &&
                                                    application.closedHintBox.indexOf(currentExercise.typeLabel) === -1
                                                }
                                                toggleHintBox={toggleHintBox}
                                                validateCheckerStep={validateCheckerStep}
                                                headingData={exerciseHeadingData}
                                                ignoreBeforeUnload={disableLeavePopup}
                                            />
                                        </Skeleton>
                                    </FluidContainer>
                                )}
                            </ExecutionRoute>
                        }
                    />
                </Routes>
            </Layout>
        </>
    );
};

PageWrapper.propTypes = {
    answers: PropTypes.array,
    appLoadedCompleted: PropTypes.func,
    appLoadedPending: PropTypes.func,
    application: PropTypes.object,
    assignmentStatus: PropTypes.object,
    assignmentEndDate: PropTypes.string,
    assignmentId: PropTypes.string,
    attemptsNumber: PropTypes.number,
    attemptsNumberFinished: PropTypes.number,
    authStatus: PropTypes.object,
    authors: PropTypes.array,
    groupCorrectionByTopic: PropTypes.bool,
    bookId: PropTypes.number,
    calculateVoteTraining: PropTypes.func,
    checkerSolutions: PropTypes.array,
    correctionPoints: PropTypes.array,
    courseTitle: PropTypes.string,
    currentIndex: PropTypes.number,
    encodedPayload: PropTypes.string,
    error: PropTypes.bool,
    exercises: PropTypes.array,
    firstPage: PropTypes.oneOf([PERFORMER, SECTIONS, DEFAULT, '']),
    geogebraExercises: PropTypes.array,
    getAssignmentById: PropTypes.func,
    getExerciseById: PropTypes.func,
    getGoogleAssignmentEndDate: PropTypes.func,
    getHomework: PropTypes.func,
    getStatus: PropTypes.func,
    getStatusArrayByGoogleClassroomAddOnSubmissionId: PropTypes.func,
    getStatusArrayByAssignmentId: PropTypes.func,
    getStatusById: PropTypes.func,
    getTrymeById: PropTypes.func,
    googleUserInfo: PropTypes.object,
    googleUserStatus: PropTypes.shape({
        error: PropTypes.bool,
        pending: PropTypes.bool,
        success: PropTypes.bool,
    }),
    heartbeat: PropTypes.func,
    heartbeatPulse: PropTypes.bool,
    homeworkId: PropTypes.string,
    homeworkStatus: PropTypes.shape({
        error: PropTypes.bool,
        fetching: PropTypes.bool,
        loaded: PropTypes.bool,
    }),
    hideModal: PropTypes.func,
    homeworkCatalogPaths: PropTypes.array,
    initializeApplication: PropTypes.func,
    isAppLoaded: PropTypes.bool,
    isAppLoading: PropTypes.bool,
    isLtiLaunch: PropTypes.bool,
    journey: PropTypes.object,
    loginId: PropTypes.string,
    notLoggedModalShowed: PropTypes.bool,
    onPlayVideo: PropTypes.func,
    onStartPageCheckboxClick: PropTypes.func,
    pauseHomework: PropTypes.func,
    phase: PropTypes.object,
    publicTitle: PropTypes.string,
    repeatTest: PropTypes.number,
    resumeGoogleLogin: PropTypes.func,
    resumeLogin: PropTypes.func,
    resumeGoogleAddOnLogin: PropTypes.func,
    saveScoreModifier: PropTypes.func,
    sendGradeErrorModalShowed: PropTypes.bool,
    sendTimeRemote: PropTypes.func,
    setAssignmentError: PropTypes.func,
    setLazeUser: PropTypes.func,
    showExerciseCorrection: PropTypes.func,
    showModal: PropTypes.func,
    showNotLoggedModal: PropTypes.func,
    showSendGradeErrorModal: PropTypes.func,
    showStartPage: PropTypes.bool,
    startHomework: PropTypes.func,
    status: PropTypes.object,
    statusArrayLoaded: PropTypes.bool,
    terminateHomework: PropTypes.func,
    tick: PropTypes.func,
    toggleHintBox: PropTypes.func,
    updateExerciseStatus: PropTypes.func,
    updateHomeworkVersion: PropTypes.func,
    validateCheckerStep: PropTypes.func,
    videos: PropTypes.array,
    disableLeavePopup: PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        answers: state.status.answers,
        application: state.application,
        assignmentStatus: state.assignment.status,
        assignmentEndDate: state.assignment.endDate,
        assignmentId: state.application.assignmentId,
        attemptsNumber: state.status.attemptsNumber,
        attemptsNumberFinished: state.status.attemptsNumberFinished,
        authStatus: state.auth.status,
        authors: state.homework.authors,
        groupCorrectionByTopic: state.application.groupCorrectionByTopic,
        bookId: state.application.bookId,
        checkerSolutions: state.homework.checkerSolutions,
        correctionPoints: state.status.correctionPoints,
        courseTitle: state.homework.courseTitle,
        currentIndex: state.status.currentExerciseIndex,
        encodedPayload: state.application.encodedPayload,
        exercises: state.homework.exercises,
        firstPage: state.application.firstPage,
        geogebraExercises: state.homework.geogebraExercises,
        googleUserInfo: state.googleAuth.userInfo,
        googleUserStatus: state.googleAuth.status,
        heartbeatPulse: state.heartbeat.pulse,
        homeworkCatalogPaths: state.homework.catalogPaths,
        homeworkId: state.homework.id,
        homeworkStatus: state.homework.status,
        isAppLoaded: state.appLoading.appLoaded.completed,
        isAppLoading: state.appLoading.appLoaded.pending,
        isLtiLaunch: state.application.isLtiLaunch,
        journey: state.homework.journey,
        notLoggedModalShowed: state.modal.notLoggedModalShowed,
        phase: state.homework.phase,
        publicTitle: state.homework.publicTitle,
        repeatTest: state.application.repeatTest,
        sendGradeErrorModalShowed: state.modal.sendGradeErrorModalShowed,
        showStartPage: state.application.showStartPage,
        status: state.status,
        statusArrayLoaded: state.status.statusArrayLoaded,
        videos: state.mediaPlayer.videos,
        disableLeavePopup: state.application.disableLeavePopup,
    };
}

const actionCreators = {
    appLoadedCompleted,
    appLoadedPending,
    calculateVoteTraining,
    getAssignmentById,
    getExerciseById,
    getGoogleAssignmentEndDate,
    getHomework,
    getStatus,
    getStatusArrayByAssignmentId,
    getStatusArrayByGoogleClassroomAddOnSubmissionId,
    getStatusById,
    getTrymeById,
    heartbeat: heartbeatAction,
    hideModal,
    initializeApplication,
    onPlayVideo,
    onStartPageCheckboxClick,
    pauseHomework,
    resumeGoogleLogin,
    resumeGoogleAddOnLogin,
    resumeLogin,
    saveScoreModifier,
    sendTimeRemote,
    setAssignmentError,
    setLazeUser,
    showExerciseCorrection,
    showModal,
    showNotLoggedModal: showNotLoggedModalAction,
    showSendGradeErrorModal,
    startHomework,
    terminateHomework,
    tick,
    toggleHintBox,
    updateExerciseStatus,
    updateHomeworkVersion,
    validateCheckerStep,
};

export default connect(mapStateToProps, actionCreators)(PageWrapper);
